const ProIcon = ({ className }) => {
  return (
    <svg className={className} width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 1L9.66667 5L13 2.33333L11.6667 9H2.33333L1 2.33333L4.33333 5L7 1Z" stroke="#DC3535" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default ProIcon